import React from 'react';
import { DecisionUploadContextType } from '../decisionUpload.types';

export const DecisionUploadContext = React.createContext<
  DecisionUploadContextType
>({
  jurisdictionsKeys: [],
  plansAllowed: [],
  jurisdictions: null,
});
